module.exports = __webpack_public_path__ + "img/nsu-logo.bda57357.png";